import React, { useEffect, useState } from 'react'
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  MarkerClusterer,
} from '@react-google-maps/api'
import './index.scss'

import pin from '../../../assets/terminals/pin (1).png'
import cargo from '../../../assets/map/big_cargo.png'
import post from '../../../assets/map/big_post.png'
import postomat from '../../../assets/map/big_postomat.png'

const Map = ({
  zoom,
  center,
  coords,
  details,
  showMarker = false,
  setTerm,
}: {
  zoom: any
  center: any
  coords: any
  details?: any
  showMarker?: boolean
  setTerm?: (value?: any) => void
}) => {
  let { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyDGhdmlq3VJzRbKTvQ9zvmvN1-nqA8Q1bU',
  })

  const [isCluster, setCluster] = useState(false)

  useEffect(() => {
    const head = document.getElementsByTagName('head')[0] as HTMLHeadElement
    const insertBefore = head.insertBefore
    head.insertBefore = function insertBeforeNew<T extends Node>(
      newElement: T,
      referenceElement: Node,
    ): T {
      if (
        (newElement as any).href &&
        (newElement as any).href.indexOf(
          '//fonts.googleapis.com/css?family=Roboto',
        ) > -1
      ) {
        console.info('Font loading is skipped')
        return newElement
      }

      insertBefore.call(head, newElement, referenceElement)
      return newElement
    }
    return () => {
      head.insertBefore = insertBefore
    }
  }, [])

  useEffect(() => {
    if (window.innerWidth <= 700) setCluster(true)

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 700) setCluster(true)
      else setCluster(false)
    })
  }, [])

  if (!isLoaded) return <></>
  return (
    <GoogleMap
      center={center}
      mapContainerStyle={{
        height: '100%',
        width: '100%',
      }}
      zoom={zoom}
    >
      {showMarker && (
        <Marker position={{ lat: coords[0].lat, lng: coords[0].lng }} />
      )}
      {!showMarker && isCluster && (
        <MarkerClusterer
          averageCenter
          enableRetinaIcons
          gridSize={30}
          zoomOnClick={true}
          styles={[
            {
              url: pin,
              width: 40,
              height: 40,
            },
          ]}
        >
          {(cluster: any) =>
            coords.map((marker: any, i: number) => (
              <Marker
                onClick={() => {
                  setTerm && setTerm(marker)
                }}
                position={{ lat: +marker.lat, lng: +marker.lng }}
                key={i}
                clusterer={cluster}
              ></Marker>
            ))
          }
        </MarkerClusterer>
      )}
      {!showMarker &&
        !isCluster &&
        coords.map((ci: any, i: number) => (
          <Marker
            icon={
              ci.typeEn == 'warehouse'
                ? cargo
                : ci.typeEn == 'poshtomat'
                ? postomat
                : post
            }
            onClick={() => {
              setTerm && setTerm(ci)
            }}
            position={{ lat: +ci.lat, lng: +ci.lng }}
            key={i}
          ></Marker>
        ))}
    </GoogleMap>
  )
}
export default Map
